export const GET_FAQS = 'Auth/GET_FAQS';

export const getFaqs = (data) => ({
  type: GET_FAQS,
  payload: data,
});

export const reducer = (state, action) => ({
  ...state,
  faqs: action.payload,
});
